module.exports = __webpack_public_path__ + "static/media/blue-jays-2024-mb-fr.4ef37029.jpg";